import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

const resources = {
  en: { translation: en },
  es: { translation: es }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Normalize language codes like 'en-US' to 'en'
      convertDetectedLanguage: (lng) => {
        const normalized = lng.split('-')[0].split('@')[0].toLowerCase();
        return ['en', 'es'].includes(normalized) ? normalized : 'en';
      }
    }
  });

export default i18n;
